<template>
	<form class="form-base">
		<v-row>
			<v-col cols="12">
				<v-text-field
					label="Наименование"
					outlined
					v-model="v.name.$model"
					:errorMessages="getValidationErrorText(v.name)"
					:disabled="disabled"
					@blur="v.name.$touch"
				/>
			</v-col>
			<v-col cols="12">
				<AddressStructuredField
					:value="v.address.$model"
					@change="v.address.$model = $event"
					:v="v.address"
					label="Адрес (место нахождения) организации"
					:notice-recovery="true"
					:global-disabled="disabled"
					@blur="v.address.$touch"
					:translationKey="translationKey ? `${translationKey}.addr` : undefined"
				/>
			</v-col>
			<v-col cols="6">
				<v-text-field
					label="ИНН организации"
					outlined
					v-model="v.inn.$model"
					:errorMessages="getValidationErrorText(v.inn)"
					:disabled="disabled"
					@blur="v.inn.$touch"
				/>
			</v-col>
		</v-row>
	</form>
</template>

<script>
import {getValidationErrorText, EMOJI, TRAILING_AND_LEADING_SPACES} from '@/utils/validate';
import {maxLength, required} from 'vuelidate/lib/validators';
import AddressStructuredField, {
	addressValidate,
} from '@/components/base/AddressStructuredField';

export const foreignOrganizationModel = {
	name: '',
	address: {},
	inn: '',
};

export const foreignOrganizationValidation = {
	name: {
		required,
		maxLength: maxLength(1000),
		EMOJI,
		TRAILING_AND_LEADING_SPACES
	},
	address: {
		required,
		...addressValidate(),
	},
	inn: {
		required,
		maxLength: maxLength(10),
		EMOJI,
		TRAILING_AND_LEADING_SPACES
	},
};

export default {
	name: 'ForeignOrganization',
	components: {AddressStructuredField},
	props: {
		v: Object,
		disabled: Boolean,
		translationKey: String,
	},
	data: () => ({
		getValidationErrorText,
	}),
};
</script>

<style scoped></style>
